import { render, staticRenderFns } from "./money_saving_tips.mpx?vue&type=template&id=3ff5d87a&component=true&componentId=money_saving_tips0de9f19b"
import script from "./money_saving_tips.mpx?vue&type=script&lang=js&component=true&componentId=money_saving_tips0de9f19b"
export * from "./money_saving_tips.mpx?vue&type=script&lang=js&component=true&componentId=money_saving_tips0de9f19b"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports